import React from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';

import SelectedSearchItemTag from './SelectedSearchItemTag';

import './SelectedSearchItems.scss';

function SelectedSearchItems(props) {
  const { tags } = props;

  if (!tags || tags.count() === 0) {
    return null;
  }

  // Drop unrenderable entries up front so each tag's `index` matches its real
  // DOM position — focus handling on removal relies on that alignment.
  const renderableTags = tags.toArray().filter((item) => item && item.get('id'));

  return (
    <div className="tree-view-dialog-selected-search-items">
      {renderableTags.map((item, index) => (
        <SelectedSearchItemTag {...props} key={item.get('id')} item={item} index={index} />
      ))}
    </div>
  );
}

SelectedSearchItems.propTypes = {
  tags: PropTypes.instanceOf(List),
  onClickThesaurusItem: PropTypes.func.isRequired,
};

export default SelectedSearchItems;
